import {useMutation} from '@apollo/react-hooks';

import type {
    EmailLeadAssociationsUpdateInput,
    UpdateEmailLeadAssociations as UpdateEmailLeadAssociationsMutation,
    UpdateEmailLeadAssociationsVariables as UpdateEmailLeadAssociationsMutationVariables,
} from 'nutshell-graphql-types';

import GET_RELATED_LEADS from '../graphql/queries/get-related-leads.graphql';

import UPDATE_EMAIL_LEAD_ASSOCIATIONS from './graphql/mutations/update-email-lead-associations.graphql';

export function useUpdateEmailLeadAssociations(
    changeLogId: string
): (arg1: EmailLeadAssociationsUpdateInput) => Promise<any> {
    const [updateEmailLeadAssociations] = useMutation<
        UpdateEmailLeadAssociationsMutation,
        UpdateEmailLeadAssociationsMutationVariables
    >(UPDATE_EMAIL_LEAD_ASSOCIATIONS);

    return (input: EmailLeadAssociationsUpdateInput) =>
        updateEmailLeadAssociations({
            variables: {input},
            update: (proxy) => {
                const emailRelatedLeadsQuery = proxy.readQuery({
                    query: GET_RELATED_LEADS,
                    variables: {changeLogId},
                });

                if (emailRelatedLeadsQuery) {
                    const updatedEmailRelatedLeads = {
                        // @ts-expect-error
                        ...emailRelatedLeadsQuery.event.payload.emailRelatedLeads,
                    } as const;

                    input.leadAssociations.forEach((updatedAssociation) => {
                        const associationIndex = updatedEmailRelatedLeads.edges.findIndex(
                            // @ts-expect-error
                            (leadEdge) => updatedAssociation.leadId === leadEdge.node.id
                        );

                        if (associationIndex !== -1) {
                            updatedEmailRelatedLeads.edges[associationIndex].isMapped =
                                updatedAssociation.isMapped;
                        }
                    });

                    proxy.writeQuery({
                        query: GET_RELATED_LEADS,
                        variables: {changeLogId},
                        data: {
                            ...emailRelatedLeadsQuery,
                            event: {
                                // @ts-expect-error
                                ...emailRelatedLeadsQuery.event,
                                payload: {
                                    // @ts-expect-error
                                    ...emailRelatedLeadsQuery.event.payload,
                                    emailRelatedLeads: {...updatedEmailRelatedLeads},
                                },
                            },
                        },
                    });
                }
            },
        });
}
